import Component from "../abstracts/Component";

export default class ListingCarouselComponent extends Component {

  get COMPONENTNAME() {
    return "ListingCarouselComponent";
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  initIntersectionObserver(carouselWrapper) {
    if (carouselWrapper?.payload) carouselWrapper = carouselWrapper.payload;
    if (carouselWrapper) {
      carouselWrapper.addEventListener("touchstart", () => {
        if (!carouselWrapper.classList.contains("slick-initialized")) {
          this.initCarouselsMobile(this.$component);
        }
      });
    }
  }

  initCarousels(carouselWrapper) {
    if (carouselWrapper?.payload) carouselWrapper = carouselWrapper.payload;
    const productLink = carouselWrapper.closest('a');
    if (carouselWrapper) {
      const image = carouselWrapper.querySelector("img");
      if(image != null && !image.complete) {
        // image is not done loading with lazyload
        image.addEventListener('load', () => {
          carouselWrapper.addEventListener("mouseover", () => {
            this.initCarouselDesktop(carouselWrapper);
          });
          carouselWrapper.addEventListener("touchstart", () => {
            this.initCarouselDesktop(carouselWrapper);
          });
       });
      } else {
        carouselWrapper.addEventListener("mouseover", () => {
          this.initCarouselDesktop(carouselWrapper);
        });
        carouselWrapper.addEventListener("touchstart", () => {
          this.initCarouselDesktop(carouselWrapper);
        });
      }
    }
    if(productLink) {
      productLink.addEventListener("focus", (event) => {
        this.initCarouselDesktop(carouselWrapper);
      });
    }
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          //const containerList = document.querySelectorAll(".carousel-wrapper");
          if (this.$component) {
            this.initCarousels(this.$component);
          }
        } else {
          if (this.$component) {
            this.startAnimationOnMobile();
            this.initIntersectionObserver(this.$component);
          }
        }
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      },
    );
  }

  startAnimationOnMobile() {
    const products = document.querySelectorAll('[data-js-component="ListingCarouselComponent"]');
    if(products && products[0]) {
      const picture = products[0].querySelector('picture');
      const mid = picture.offsetWidth / 2;
      document.documentElement.style.setProperty("--final-x", -mid + "px");
      setTimeout(() => {
        products[0].classList.add("bounce");
      }, 1000);
    }
  }

  initCarouselDesktop(carouselWrapper) {
    if (!carouselWrapper.classList.contains("slick-initialized")) {
      const arrowL = carouselWrapper.previousElementSibling;
      const arrowR = carouselWrapper.nextElementSibling;
      arrowL.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowR.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowL.addEventListener("keyup", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
      arrowR.addEventListener("keyup", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });

      $(carouselWrapper).slick({
        lazyLoad: "ondemand", // ondemand or progressive
        adaptiveHeight: true,
        prevArrow: arrowL,
        nextArrow: arrowR,
      });
    }
  }

  initCarouselsMobile(elem) {
    $(elem).slick({
      arrows: false,
    });
  }

  render() {
    super.render();
    this.importLibrary();
    this.$on(this.$customEvents.LISTING_CAROUSEL_EVENTS.show, ({ event, payload }) => {
      if (payload) {
        this.initCarousels(payload);
      }
    });
  }
}
